<template>
	<div>
		<header class="sub-header">
			<h2>Choose an integration to get data in just a few clicks</h2>
		</header>
		<div class="help">
			<h4><a href="https://support.initialstate.com/hc/en-us/articles/360036577972-Introduction-to-Integration-Marketplace" target="_blank">Getting Started Guide</a></h4>
		</div>
		<article class="layout-3-col-wrapper">
			<div class="left"></div>
			<div class="middle">
				<section>
						<spinner v-if="exploreStatus.loading"></spinner>
						<div :class="`items`" v-if="!exploreStatus.loading" >
								<!-- List
								<div  :class="`item-card ${exploreItem.state}`" v-for="exploreItem in sortedExploreItems" v-bind:key="exploreItem.id">
									<div class="item-icon">
										<div class="item-logo">
											<img v-bind:src="exploreItem.logo">
										</div>
									</div>
									<div class="item-body">
										<h3 class="item-title">
											{{exploreItem.name}} <span v-if="exploreItem.isAvailable()"> <small><span class="token"></span> <span>{{exploreItem.getCostLabel()}}</span></small></span>
										</h3>
										<p class="short-description">
											{{exploreItem.shortDescription}}
										</p>
									</div>
									<div class="item-action">
										<div v-if="exploreItem.state === 'PREVIEW'">
											<span>Coming Soon!</span>
										</div>
										<router-link v-else class="rigid outline-btn" :to="{ name: 'marketplaceItem', params: { itemId: exploreItem.id }}">Details</router-link>
									</div>
								</div> -->

								<!-- Tiles -->
								<div  :class="`item-tile ${exploreItem.state}`" v-for="exploreItem in sortedExploreItems" v-bind:key="exploreItem.id + '2'">
									<h3 class="item-title">
											{{exploreItem.name}} <small><span class="token" v-if="exploreItem.isAvailable()"></span> <span>{{exploreItem.getCostLabel()}}</span></small>
										</h3>
											<div class="item-icon">
										<div class="item-logo">
											<img v-bind:src="exploreItem.logo">
										</div>
									</div>


										<div class="short-description">
											{{exploreItem.shortDescription}}
										</div>

										<div class="item-action">
											<div v-if="exploreItem.state === 'PREVIEW'">
												<span>Coming Soon!</span>
											</div>

											<router-link v-else class="rigid outline-btn" :to="{ name: 'marketplaceItem', params: { itemId: exploreItem.id }}">Details</router-link>
										</div>
								</div>

								<!-- Feedback Tile -->
								<div  class="item-tile" >
									<h3 class="item-title">More to Come</h3>
									<div class="item-icon">
										<div class="item-logo">
											<i class="fas fa-question fa-3x"></i>
										</div>
									</div>
									<div class="short-description">
										We would like to know more about what you want.
									</div>
									<div class="item-action">
										<a class="rigid outline-btn" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeGqAQmCX87AuFA0xF9UxEHnKFxHtGsABNImNzqSWpKkm7_IQ/viewform?usp=sf_link">Give Feedback</a>
									</div>
								</div>

								<div v-if="!exploreItems || !exploreItems.length" class="text-center">
									Hmm... something went wrong.
									<div v-if="!(user && user.roles && user.roles.optimus && user.roles.optimus.mp && user.roles.optimus.mp.item && user.roles.optimus.mp.item.add)">
										Are you sure you're supposed to be here?
									</div>
								</div>
						</div>
				</section>
			</div>
			<div class="right"></div>
		</article>
	</div>
</template>

<script>
	import SettingExpand from '../components/SettingExpand';
    import Spinner from '../components/Spinner';
	import { mapGetters } from 'vuex';

	export default {
		name: 'Marketplace',
		filters: {},
		data(){
			return {};
		},
		components: {
			SettingExpand,
			Spinner
		},
		computed: {
			...mapGetters([
				'exploreItems',
				'exploreStatus',
				'roles',
				'user'
			]),
			sortedExploreItems: function() {
                function compare(a, b) {
                    if (a.name < b.name) {
                        return -1;
                    } else if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                }
                return [...this.exploreItems].sort(compare);
            }
		},
		methods: {
		},
		created() {
			if (!(this.exploreItems && this.exploreItems.length)) {
				this.$store.dispatch('ITEMS_EXPLORE_REQUEST');
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


	.items{
		grid-gap: 10px 10px;
		display:grid;
		grid-template-columns: repeat(auto-fill, 280px);
		justify-content: center;
	}
	.item-card{
		display:none;
	}
	.item-icon{
		display: inline-block;
		vertical-align: middle;
	}
	.item-logo{
		border: none;
		background: transparent;
		box-shadow:none;
		text-align: center;
		margin:auto;
		height: auto;
	}
	.item-action{
		padding: 0;
		margin: 10px auto;
	}
	
	.help{
		text-align: center;
		margin: auto;
	}

	.sub-header ~ .layout-3-col-wrapper > .middle{
		width:100%;
		flex-basis:100%;
		padding:20px 0 40px;
	}
	.layout-3-col-wrapper{
		flex-wrap: wrap;
	}
	.sub-header h2{
		text-align: center;
		margin: auto;
	}

	.items{
		max-width: 950px;
		margin:auto;
	}

	.layout-3-col-wrapper{
		flex-wrap: wrap;
	}
	.right, .left{
		flex-basis: 0;
	}



	small{
		padding-left:5px;
		vertical-align: middle;
		padding-left: 5px;
		vertical-align: middle;
		position: absolute;
		right: 10px;
		bottom: 15px;
	}

	small span{
		vertical-align: middle;
	}
	.header {
		height: 15%;
		padding-top: 5%;
		padding-bottom: 5%;
	}
	.header h1 {
		margin-top: 20px;
		margin-bottom: 8px;
		font-size: 3em;
	}

	.loading{
		margin-top:150px;
	}

	.sub-header{
		color:#222;
		text-align: center;
		padding: 15px 0;
		display:flex;
		flex-direction: row;
		max-width: 600px;
		margin: auto;
		padding-top: 30px;
		align-items: center;

	}
	.sub-header ~ .layout-3-col-wrapper > .middle{
		padding-top: 0;
	}
	.sub-header h2{
		margin:0 15px;
	}
	.sub-header hr{
		flex: 1 1 auto;
		border:none;
		border-bottom: solid thin #222;
	}
	.PREVIEW.item-card{
		opacity: 0.5;
	}

	.short-description{
		color: #444;
	}

	.item-tile{
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 3px;
		border: .66px solid white;
		border-radius: 3px;
		box-shadow: 5px 5px 10px 0 rgba(61,66,67,0.05);
		padding: 15px;
		min-width: 200px;
		justify-content: space-between;
		background-color: #f1f3f6;
		position: relative;
		background-image: linear-gradient(to right bottom, #f1f3f6, #eef0f4, #eaedf3, #e7ebf1, #e3e8ef);
		z-index: 100;
	}
	.item-tile:before {
		background-color: #f1f3f6;
		background-image:none;
		border-radius: inherit;
		content: '';
		display: block;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
		width: 100%;
		z-index: -100;
		transition: opacity 0.2s;
	}

	.item-tile:hover .outline-btn{
		color:white;
		transition: all .2s ease;
		border-color: rgba(16,116,231);
		background-color: rgba(16,116,231);
		color: white;
		font-size: 12px;
	}
	.item-tile:hover .outline-btn:hover{
		font-size: 12px;
		background-color: #2C8EFF;
		text-shadow: 0 2px 4px rgba(5,9,133,0.50);
		color: white;
		border-color: rgba(16,116,231);
	}
	.item-tile:hover::before{
		opacity: 1;
	}

	.item-tile > div{
		margin: 10px auto;
	}
	/* // Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
	.items{
		grid-gap: 10px 10px;
		display:grid;
		grid-template-columns: repeat(auto-fill, 280px);
		justify-content: center;

	}
	.item-card{
		display:none;
	}
	.item-icon{
		display: inline-block;
		vertical-align: middle;
	}

	.item-logo{
		border: none;
		background: transparent;
		box-shadow:none;
		text-align: center;
		margin:auto;
		height: auto;
	}
	.item-action{
		padding: 0;
		margin: 10px auto;
	}

	hr {
		display:none;
	}
	.sub-header ~ .layout-3-col-wrapper > .middle{
		width:100%;
		flex-basis:100%;
		padding:20px 0 40px;
	}
	.layout-3-col-wrapper{
		flex-wrap: wrap;
	}
		.sub-header h2{
		text-align: center;
		margin: auto;
	}
  }

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
	.items{
		grid-gap: 10px 10px;
		display:grid;
		grid-template-columns: 45% 45%;
		justify-content: center;
	}
	.item-card{
		display:none;
	}
	.item-icon{
		display: inline-block;
		vertical-align: middle;
	}

	.item-logo{
		border: none;
		background: transparent;
		box-shadow:none;
		text-align: center;
		margin:auto;
		height: auto;
	}
	.item-action{
		padding: 0;
		margin: 10px auto;
	}
	hr {
		display:none;
	}
	.sub-header ~ .layout-3-col-wrapper > .middle{
		width:100%;
		flex-basis:100%;
		padding:20px 0 40px;
	}
	.layout-3-col-wrapper{
		flex-wrap: wrap;
	}
	.sub-header h2{
		text-align: center;
		margin: auto;
	}
}

/* // Medium devices (tablets, 768px and up) */
/* @media (min-width: 768px) and (max-width: 991.98px) { .item-tile{display:none;}} */

/* // Large devices (desktops, 992px and up) */
/* @media (min-width: 992px) and (max-width: 1199.98px) {.item-tile{display:none;}  } */

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
	/* .item-tile{display:none;} */
	.items{
		grid-gap: 10px 10px;
		display:grid;
				grid-template-columns: repeat(auto-fill, 280px);

		justify-content: center;
	}
	.item-card{
		display:none;
	}
	.item-icon{
		display: inline-block;
		vertical-align: middle;
	}

	.item-logo{
		border: none;
		background: transparent;
		box-shadow:none;
		text-align: center;
		margin:auto;
		height: auto;
	}
	.item-action{
		padding: 0;
		margin: 10px auto;
	}

	.sub-header ~ .layout-3-col-wrapper > .middle{
		width:100%;
		flex-basis:100%;
		padding:20px 0 40px;
	}
	.layout-3-col-wrapper{
		flex-wrap: wrap;
	}
	.sub-header h2{
		text-align: center;
		margin: auto;
	}
}

</style>



// WEBPACK FOOTER //
// src/views/Marketplace.vue